import { Logo as kalshi } from './kalshi';
import { Logo as polymarket } from './polymarket';

/**
 * Full-color venue logos, keyed by market name. Unlike the monochrome logos in `markets/`, these
 * carry their own background and brand colors and so are not recolored by the theme.
 */
export const MARKET_BRAND_LOGOS = {
  kalshi,
  polymarket,
} as const;

export type MarketWithBrandLogo = keyof typeof MARKET_BRAND_LOGOS;

const MARKETS_WITH_BRAND_LOGO = new Set<string>(Object.keys(MARKET_BRAND_LOGOS));

export function hasMarketBrandLogo(market: string | undefined): market is MarketWithBrandLogo {
  return market != null && MARKETS_WITH_BRAND_LOGO.has(market);
}
